import Model from '../libs/ModelClass';

export default class Product extends Model {
  static collectionName = 'products';

  constructor(data) {
    super(data);
  }
}